import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import Button from "../../Components/FormElements/Button";

const ErrorPage = () => {
  const history = useHistory();

  const irProductos = () => {
    history.push("/productos");
  };

  const volverIntentar = () => {
    history.goBack();
  };

  const location = useLocation();
  const timeOut = location.state.timeOut;

  return (
    <div className="wrap">
      <div className="">
        <div className="content-error">
          <div className="content-error__box">
            <div className="content-error__mueble">
              <div className={`content-error__warning`}></div>
            </div>
          </div>
          <div>
            <div className="content-error__texts">
              <p className="content-error__title">¡Lo sentimos!</p>
              {timeOut ? (
                <p className="content-error__subtitle">
                  El tiempo para cargar la información está tomando más tiempo
                  de lo normal. Por favor, vuelve a intentar.
                </p>
              ) : (
                <p className="content-error__subtitle">
                  No pudimos continuar con el proceso que realizabas. Por favor,
                  vuelve a intentar.
                </p>
              )}
            </div>
            <div className="content-error__actions">
              <Button type="button" onClick={volverIntentar}>
                Volver a intentar
              </Button>
              <Button
                type="button"
                className="is-secondary"
                onClick={irProductos}
              >
                Ir a productos
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
